import { largeTabletMax, mobileXXLargeMax } from '@propertypal/shared/src/constants/mediaQueries';
import styled from 'styled-components';
import { RowAlignCenter } from '../layout';

export const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  margin: 60px 0;

  @media (${largeTabletMax}) {
    margin: 30px 0;
  }

  @media (${mobileXXLargeMax}) {
    flex-direction: column;
  }
`;

export const KeyDetails = styled.section`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 40px;

  @media (${largeTabletMax}) {
    max-width: 400px;
    flex-wrap: wrap;
  }
`;

export const SummaryItem = styled.div`
  display: flex;
  flex-direction: row;
  margin-right: 10px;
  margin-bottom: 15px;
  align-items: center;
`;

export const AgentBox = styled.div`
  background: ${(props) => props.theme.background};
  min-width: 300px;
  padding: 20px;
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (${mobileXXLargeMax}) {
    margin-top: 30px;
    min-width: auto;
    width: 100%;
  }
`;

export const ShowPhoneNumber = styled.div`
  display: block;
  width: 100%;

  @media (${mobileXXLargeMax}) {
    display: none;
  }
`;

export const CallAgentBox = styled.div`
  display: none;
  width: 100%;

  @media (${mobileXXLargeMax}) {
    display: block;
  }
`;

export const Title = styled.h3`
  color: ${(props) => props.theme.textDark};
  font-size: 20px;
  text-align: center;
  margin-bottom: 15px;
`;

export const AgentLogo = styled.img`
  max-width: 250px;
  max-height: 120px;
  margin-bottom: 10px;
`;

export const AwardLogo = styled.img`
  max-width: 250px;
  max-height: 80px;
  margin-top: 15px;
`;

export const AgentText = styled.p`
  color: ${(props) => props.theme.textMid};
  font-size: 14px;
  text-align: center;
`;

export const AgentBoxFixed = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background-color: ${(props) => props.theme.background};
  width: 100%;
  height: 60px;
  z-index: 10;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border-bottom: 1px solid ${(props) => props.theme.keyline};
  transition: 300ms all;

  img {
    max-width: 200px;
    max-height: 40px;
  }

  ${AgentText} {
    text-align: left;
  }

  @media (${mobileXXLargeMax}) {
    ${RowAlignCenter} {
      display: none;
    }
  }
`;

export const NameAndPSRTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AgentBoxFixedButtons = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  max-width: 400px;

  @media (${mobileXXLargeMax}) {
    max-width: 600px;
  }
`;

export const LicenceWarning = styled.a`
  width: 20px;
  height: 20px;
  background-color: ${(props) => props.theme.primary};
  border-radius: 10px;
  display: inline-block;
  font-weight: bold;
  color: ${(props) => props.theme.white};
  margin-left: 5px;
`;

export const AwardBox = styled.a`
  border: 2px solid ${(props) => props.theme.gold};
  border-radius: 8px;
  padding: 20px 30px;
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;

  p {
    font-weight: 600;
    margin-bottom: 10px;
    color: ${(props) => props.theme.textDark};
  }

  img {
    max-height: 80px;
  }
`;
